import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {CplItem} from '../../../model/cpl-item.model';
import {SafeHtml} from '@angular/platform-browser';
import {UserAssignment} from '../../../supervision-management/compliance-items/compliance-item/enums/user-assignment.enum';
import {CplCycle} from '../../../model/cpl-cycle.model';
import {FileAttachment} from '../../../model/file-attachment.model';
import {FileService} from '../../../services/file.service';
import { ComplianceItemHelpersService } from '../../../services/compliance-item-helpers/compliance-item-helpers.service';
import { VerificationHistory } from 'src/app/model/cpl-verification-history.model';
import { CplUserStatus } from 'src/app/supervision-management/compliance-items/compliance-item/enums/cpl-user-status.enum';
import { FileDownloadHandler, PortalSettings } from '@edl-development/edl-common';

@Component({
    selector: 'compliance-item-cycle-details',
    templateUrl: './compliance-item-cycle-details.component.html',
    styleUrls:   ['./compliance-item-cycle-details.component.scss']
})
export class ComplianceItemCycleDetailsComponent {
    @Input() complianceItem: CplItem;
    @Input() userCycle: CplCycle;
    @Input() verificationHistory: Array<VerificationHistory>;
    @Input() evidence: Array<FileAttachment>;

    @Output() completeQuestionnaire = new EventEmitter<string>();

    portalSettings:PortalSettings;
    instructions: SafeHtml;

    CourseType:String;
    CECPerformanceStandard:String;
    UserAssignment = UserAssignment;
    CplUserStatus = CplUserStatus;

    constructor(
        public complianceItemHelpersService: ComplianceItemHelpersService,
        private fileService: FileService,
        private fileHandler: FileDownloadHandler
    ) {}

    viewAttachement(attachment: FileAttachment) {
        this.fileService
            .getFileResponse(attachment.FileID)
            .subscribe((fileResponse : Blob) => {
                this.fileHandler.saveFile(fileResponse, attachment.FileName);
            });
    }

    onCompleteQuestionnaire(QfmID: string) {
        this.completeQuestionnaire.emit(QfmID);
    }

    currentStageUsers() {
        const verificationStage = this.complianceItem.VerificationStages?.find(v => v.StageID === this.userCycle.VerificationStage?.StageID);

        return verificationStage?.Approvers ?? [];
    }
}